<script setup>
const props = defineProps({
    quote: {
        type: String,
        required: true,
    }
});
</script>

<template>
    <section class="block blog block-blog-quote container py-9 lg:py-18" tabindex="-1">
        <div class="quote flex gap-5 rounded-(--radius) overflow-hidden relative"
            style="background: linear-gradient(164.84deg, var(--magenta) 8.34%, var(--purple) 75.13%, var(--orange) 101.89%);">
            <MessHtml tag="blockquote" class="text-white normal-case font-hubspot-serif font-normal leading-[1.2] tracking-normal text-[calc(34/var(--base-fs)*1rem)] p-10 lg:py-[70px] lg:px-[115px] max-md:text-[1.25rem] max-md:leading-[1.3] relative z-1" :html="quote" />
            <img src="/img/2026/blog/quote-shard.png" loading="lazy" decoding="async" alt="" aria-hidden="true"
                class="absolute bottom-0 right-0 pointer-events-none z-0 w-[400px] max-w-[50%]" />
        </div>
    </section>
</template>

<style>

/* [child] svg fill inside quote */
.block-blog-quote .quote .svg-container .mess-svg path {
    fill: var(--orange-dark);
}

/* [pseudo] remove top padding when consecutive quote blocks */
.builder-block:has(.block-blog-quote) + .builder-block:has(.block-blog-quote) .block-blog-quote {
    padding-top: 0;
}

/* [child] mobile mess-svg spacing */
@media (max-width: 768px) {
    .block-blog-quote .quote {
        display: block;
    }

    .block-blog-quote .quote .mess-svg {
        margin-bottom: 2rem;
    }
}
</style>
